import React, { useState, useEffect } from 'react';
import '../styles/ServiceConfig.css';
import { getServices, addService, updateService, deleteService } from '../services/api';

function ServiceConfig() {
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState({ name: '', provider: '', description: '' });
  const [editService, setEditService] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await getServices();
        setServices(data);
      } catch (err) {
        console.error('Failed to fetch services:', err);
      }
    };
    fetchServices();
  }, []);

  const handleAddService = async (e) => {
    e.preventDefault();
    try {
      const response = await addService(newService);
      setServices([...services, response]);
      setNewService({ name: '', provider: '', description: '' });
    } catch (err) {
      alert('Failed to add service.');
    }
  };

  const handleUpdateService = async (e) => {
    e.preventDefault();
    try {
      await updateService(editService.id, editService);
      setServices(services.map(s => s.id === editService.id ? editService : s));
      setEditService(null);
    } catch (err) {
      alert('Failed to update service.');
    }
  };

  const handleDeleteService = async (serviceId) => {
    if (window.confirm('Are you sure you want to delete this service?')) {
      try {
        await deleteService(serviceId);
        setServices(services.filter(s => s.id !== serviceId));
      } catch (err) {
        alert('Failed to delete service.');
      }
    }
  };

  return (
    <div className="ap-service-config">
      <h2 className="ap-sc-title">Service Configuration</h2>
      <form className="ap-add-service-form" onSubmit={handleAddService}>
        <input className="ap-sc-input" name="name" placeholder="Service Name" value={newService.name} onChange={(e) => setNewService({ ...newService, name: e.target.value })} required />
        <input className="ap-sc-input" name="provider" placeholder="Provider" value={newService.provider} onChange={(e) => setNewService({ ...newService, provider: e.target.value })} required />
        <textarea className="ap-sc-textarea" name="description" placeholder="Description" value={newService.description} onChange={(e) => setNewService({ ...newService, description: e.target.value })} required />
        <button className="ap-sc-btn" type="submit">Add Service</button>
      </form>
      <div className="ap-service-list">
        {services.map(service => (
          <div key={service.id} className="ap-service-card">
            <h3 className="ap-service-name">{service.name}</h3>
            <p className="ap-service-provider">{service.provider}</p>
            <p className="ap-service-desc">{service.description}</p>
            <button className="ap-edit-btn" onClick={() => setEditService(service)}>Edit</button>
            <button className="ap-delete-btn" onClick={() => handleDeleteService(service.id)}>Delete</button>
          </div>
        ))}
      </div>
      {editService && (
        <form className="ap-edit-service-form" onSubmit={handleUpdateService}>
          <h3 className="ap-edit-title">Edit Service</h3>
          <input className="ap-sc-input" name="name" value={editService.name} onChange={(e) => setEditService({ ...editService, name: e.target.value })} required />
          <input className="ap-sc-input" name="provider" value={editService.provider} onChange={(e) => setEditService({ ...editService, provider: e.target.value })} required />
          <textarea className="ap-sc-textarea" name="description" value={editService.description} onChange={(e) => setEditService({ ...editService, description: e.target.value })} required />
          <button className="ap-sc-btn" type="submit">Save</button>
          <button className="ap-cancel-btn" type="button" onClick={() => setEditService(null)}>Cancel</button>
        </form>
      )}
    </div>
  );
}

export default ServiceConfig;